import * as types from '../actionType'

const initialState = []

const userOrderDisputed = (state = initialState, action) => {
    switch (action.type) {
        case types.USER_POST_DISPUTED_ORDER:
            return action.payload
        default:
            return state
    }
}


export { userOrderDisputed }